<template>
  <!-- eslint-disable -->
<div>
  <v-dialog v-model="show"  persistent>
    <v-card>
      <v-card-title>
        <h3>Calamity Calls</h3>
      </v-card-title>
      <v-card-text style="padding: 0 25px 10px 25px !important;">
        <div v-for="(data, idx) in calamityPackageList" :Key="idx" style="padding: 10px 0;">
          <h2>{{data.ClientName}}</h2>
          <v-layout style="padding-bottom: 15px;">
            <v-flex xs12 sm6>
              <div><strong># of Packages:</strong>&emsp;{{getTotal(data.CalamityList, "TotalPackages")}}</div>
              <div><strong># Needs Call:</strong>&emsp;{{getTotal(data.CalamityList, "NeedsCalls")}}</div>
            </v-flex>
            <v-flex xs12 sm6>
              <div><strong>Client Calls/Hour limit:</strong>&emsp;{{data.CallOptions.Option_98}}</div>
              <div><strong>Calls Cutoff time:</strong>&emsp;{{getCutoffTime(data.CallOptions)}}  {{getTimeZoneCode(data.CallOptions.Option_102)}}</div>
            </v-flex>
          </v-layout>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-layout>
                    <v-flex xs6>
                      <div><h3>{{data.CalamityList.filter(x => x.isSelected > 0).length}}/{{data.CalamityList.filter(x => x.NeedsCalls > 0).length}} Calamities Selected</h3></div>
                    </v-flex>
                    <v-flex xs6>
                      <div><h3>{{getNumberSelectedPackages(data)}}/{{getTotal(data.CalamityList, "NeedsCalls")}} Total Calls</h3></div>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="getNumberSelectedPackages(data) > 0">
                    <v-flex xs6>
                      <div><strong>EST time of completion:</strong>&emsp;{{getEstimatedTimeOfCompletion(data, "hh:mm A z")}} ({{Math.round(getNumberSelectedPackages(data)/data.callsPerHour * 100) / 100}} hours) </div>
                    </v-flex>
                    <v-flex xs6>
                      <div v-if="estimateBeyondCuffOff(data) > 0" style="font-weight: 500; color: #d80505;">
                        {{estimateBeyondCuffOff(data)}} hours past client cutoff.
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-data-table :mobile-breakpoint="0" single-expand show-expand show-select hide-default-footer disable-pagination :items="data.CalamityList" item-key="CalamityId" :headers="headers" :sort-by.sync="sortBy" :sort-desc.sync="descending" >
                      <template v-slot:header.data-table-select="{ on, props }">
                        <v-checkbox :indeterminate="isSelectAll(data.CalamityList) === 0" :false-value="-1" :true-value="1" :input-value="isSelectAll(data.CalamityList)" @change="selectAll(data.CalamityList); forceUpdate();"  style="padding-top: 0; margin-top: 0;" hide-details></v-checkbox>
                      </template>
                      <template v-slot:item.data-table-select="{ isSelected, select, item }">
                        <v-checkbox style="padding-top: 0; margin-top: 0;" :disabled="item.NeedsCalls == 0 && false" v-model="item.isSelected" hide-details @input="select($event)" @change="forceUpdate"></v-checkbox>
                      </template>
                      <template v-slot:expanded-item="{ item, headers }" item-key="HashKey">
                        <td :colspan="headers.length" style="padding: 0;">
                          <div text >
                            <template>
                              <v-simple-table dense style="padding: 15px 25px; background-color: transparent;">
                                <template v-slot:default>
                                  <thead>
                                    <tr>
                                      <th class="text-left"></th>
                                      <th class="text-left">Eligible</th>
                                      <th class="text-left">Ineleigible</th>
                                      <th class="text-left">Total</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td style="padding-left: 35px"><strong># Packages</strong></td>
                                      <td>{{item.NeedsCalls}}</td>
                                      <td>{{item.Ineligible}}</td>
                                      <td>{{item.TotalPackages}}</td>
                                    </tr>
                                    <tr>
                                      <td style="padding-left: 35px"><strong>Contents Value</strong></td>
                                      <td>${{item.ContentsValue.toFixed(2)}}</td>
                                      <td>${{item.ContentsValueIneligible.toFixed(2)}}</td>
                                      <td>${{item.ContentsValueTotal.toFixed(2)}}</td>
                                    </tr>
                                    <tr>
                                      <td style="padding-left: 35px"><strong># Refrigerated Packages</strong></td>
                                      <td>{{item.Refrigerated}}</td>
                                      <td>{{item.RefrigeratedIneligible}}</td>
                                      <td>{{item.RefrigeratedTotal}}</td>
                                    </tr>
                                    <tr>
                                      <td style="padding-left: 35px"><strong>Refrigerated Contents Value</strong></td>
                                      <td>${{item.RefContentsValue.toFixed(2)}}</td>
                                      <td>${{item.RefContentsValueIneligible.toFixed(2)}}</td>
                                      <td>${{item.RefContentsValueTotal.toFixed(2)}}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="4"><h3>Schedueld Delivery Dates</h3></td>
                                    </tr>
                                    <tr v-for="date in item.DeliveryDates" :key="date.Date">
                                      <td style="padding-left: 35px"><strong>{{date.Date}}</strong></td>
                                      <td>{{date.Eligible}}</td>
                                      <td>{{date.Ineligible}}</td>
                                      <td>{{date.Total}}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="4"><h3>Transit Status Summary</h3></td>
                                    </tr>
                                    <tr v-for="state in item.TransitStates" :key="state.Id">
                                      <td style="padding-left: 35px"><strong>{{state.Name}}</strong></td>
                                      <td>{{state.Eligible}}</td>
                                      <td>{{state.Ineligible}}</td>
                                      <td>{{state.Total}}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="4"><h3>Time Zone Summary</h3></td>
                                    </tr>
                                    <tr v-for="(timeZone, idx) in item.TimeZones" :key="idx">
                                      <td style="padding-left: 35px"><strong>{{timeZone.Name}}</strong></td>
                                      <td>{{timeZone.Eligible}}</td>
                                      <td>{{timeZone.Ineligible}}</td>
                                      <td>{{timeZone.Total}}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="4"><h3>Package Ineligiblity Reasons</h3></td>
                                    </tr>
                                    <tr v-if="item.Notified > 0">
                                      <td colspan="2" style="padding-left: 35px"><strong>Already Notified</strong></td>
                                      <td colspan="2">{{item.Notified}}</td>
                                    </tr>
                                    <tr v-if="item.PastDeliveryDate > 0">
                                      <td colspan="2" style="padding-left: 35px"><strong>Past Delivery Date</strong></td>
                                      <td colspan="2">{{item.PastDeliveryDate}}</td>
                                    </tr>
                                    <tr v-if="item.FutureDeliveryDate > 0">
                                      <td colspan="2" style="padding-left: 35px"><strong>Later Delivery Date</strong></td>
                                      <td colspan="2">{{item.FutureDeliveryDate}}</td>
                                    </tr>
                                    <tr v-if="item.Closed > 0">
                                      <td colspan="2" style="padding-left: 35px"><strong>Closed</strong></td>
                                      <td colspan="2">{{item.Closed}}</td>
                                    </tr>
                                    <tr v-if="item.ReturnToSender > 0">
                                      <td colspan="2" style="padding-left: 35px"><strong>Return To Sender</strong></td>
                                      <td colspan="2">{{item.ReturnToSender}}</td>
                                    </tr>
                                    <tr v-if="item.DoNotContact > 0">
                                      <td colspan="2" style="padding-left: 35px"><strong>Do Not Contact</strong></td>
                                      <td colspan="2">{{item.DoNotContact}}</td>
                                    </tr>
                                    <tr v-if="item.Tier2 > 0">
                                      <td colspan="2" style="padding-left: 35px"><strong>Tier 2</strong></td>
                                      <td colspan="2">{{item.Tier2}}</td>
                                    </tr>
                                    <tr v-if="item.Cpu > 0">
                                      <td colspan="2" style="padding-left: 35px"><strong>CPU (Root Cause)</strong></td>
                                      <td colspan="2">{{item.Cpu}}</td>
                                    </tr>
                                    <tr v-if="item.CsrCpu > 0">
                                      <td colspan="2" style="padding-left: 35px"><strong>CSR-CPU (Root Cause)</strong></td>
                                      <td colspan="2">{{item.CsrCpu}}</td>
                                    </tr>
                                    <tr v-if="item.MonCpu > 0">
                                      <td colspan="2" style="padding-left: 35px"><strong>MON-CPU (Root Cause)</strong></td>
                                      <td colspan="2">{{item.MonCpu}}</td>
                                    </tr>
                                    <tr v-for="state in item.TransitStates" :key="state.Name" v-show="state.Total > 0 && (state.Id > 5 || state.Id == 0)">
                                      <td colspan="2" style="padding-left: 35px"><strong>{{state.Name}} (Transit State)</strong></td>
                                      <td colspan="2">{{state.Total}}</td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                              <v-expansion-panels style="padding: 15px; max-width: calc(100vw - 147px);">
                                <v-expansion-panel>
                                  <v-expansion-panel-header>
                                    <h3>Package Info</h3>
                                  </v-expansion-panel-header>
                                  <v-expansion-panel-content>
                                    <v-card>
                                      <v-card-text style="overflow: auto;">
                                        <v-data-table class="no-wrap-th" disable-pagination hide-default-footer :items="item.Packages" :headers="subTableHeaders" :mobile-breakpoint="0" :sort-by.sync="subTableSortBy">
                                          <template v-slot:item="{ item }">
                                            <tr :style="{'background-color': item.NeedsNotification ? '#85e085' : '#ffb3b3' }">
                                              <td>{{item.TrackingNumber}}</td>
                                              <td>{{item.Notified ? 'YES' : '-'}}</td>
                                              <td>{{formatTime(item.ScheduledDeliveryDate)}}</td>
                                              <td>{{item.TransitState}}</td>
                                              <td>{{item.TimeZoneName}}</td>
                                              <td>${{item.ContentsValue.toFixed(2)}}</td>
                                              <td>{{item.IsRef == 2 ? "YES" : "-"}}</td>
                                              <td>{{item.Ineligible ? getIneligbleReasons(item) : "-"}}</td>
                                            </tr>
                                          </template>
                                        </v-data-table>
                                      </v-card-text>
                                    </v-card>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
                              </v-expansion-panels>
                            </template>
                          </div>
                        </td>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <div v-if="getNumberSelectedPackages(data) > 0">
            <h4 style="padding-top: 25px;">Calls/Hr</h4>
            <v-container fluid grid-list-lg style="padding-bottom: 0;">
              <v-layout row wrap >
                <v-flex xs9 style="padding: 0 10px;">
                  <v-slider @change="forceUpdate" :color="data.callsPerHour > data.CallOptions.Option_98 ? 'red' : 'blue'" thumb-label v-model="data.callsPerHour" :min="minCallsPerHour" :max="getTotal(data.CalamityList, 'NeedsCalls') < data.CallOptions.Option_98? data.CallOptions.Option_98 : getTotal(data.CalamityList, 'NeedsCalls')"/>
                </v-flex>
                <v-flex xs3 style="padding: 0 0 0 25px;">
                  <v-text-field v-model="data.callsPerHour" style="padding-top: 0;" class="mt-0" type="number" :max="100" :min="1" ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
          <hr>
        </div>
      </v-card-text>
      <v-card-actions style="padding: 0 25px 20px 25px;">
        <v-btn color="primary" text @click.stop="show=false">Close</v-btn>
        <v-btn color="primary" :disabled="submitting || !hasSelectedCalamity()" text @click.stop="submit()">Submit</v-btn>
        <v-progress-circular v-show="submitting" indeterminate color="primary"></v-progress-circular>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="warningDialog" persistent max-width="525">
      <v-card v-if="clientErrors.length > 0">
        <v-card-title class="headline">Warnnig</v-card-title>
        <div v-for="(error, idx) in clientErrors" :key="idx">
          <h3 style="padding: 0 16px;">{{error.clientName}}</h3>
          <!-- More Than 75 Calls -->
          <div v-if="error.errorNum == 1">
            <v-card-text>
              Please be advised this campaign is set to send over {{error.clientMaxCalls}} calls per hour which will generate a high number of transfers back into our customers phone center.  
              If you have already confirmed call scheduling with the client or your superior move forward.  
              If you have not confirmed this with the client or your superior please reach out to your superior for guidance.  
              Receiving guidance in a timely manner is critical so escalate above your superior if you do not receive a prompt response.
            </v-card-text>
          </div>
          <!-- Past Center Close Time -->
          <div v-if="error.errorNum == 2">
            <v-card-text>
              Please be advised this campaign is set to end after the client call center close time we have in the system ({{error.clientCutoffTime}} {{getTimeZoneCode(error.clientTimeZoneCode)}}).  
              This potentially will cause issues where the Consignee tries to transfer into a closed call center.  
              If you have already confirmed call scheduling with the client or your superior move forward.  
              If you have not confirmed this with the client or your superior please reach out to your superior for guidance.  
              Receiving guidance in a timely manner is critical so escalate above your superior if you do not receive a prompt response. 
            </v-card-text>
          </div>
          <!-- Both -->
          <div v-if="error.errorNum == 3">
            <v-card-text>
              Please be advised this campaign is set to send over {{error.clientMaxCalls}} calls per hour which will generate a high number of transfers back into our customers phone center and this campaign is set to end after the client call center close time we have in the system ({{error.clientCutoffTime}} {{getTimeZoneCode(error.clientTimeZoneCode)}}).  
              This potentially will cause issues where the Consignee tries to transfer into a closed call center.  
              If you have already confirmed call scheduling with the client or your superior move forward. 
              If you have not confirmed this with the client or your superior please reach out to your superior for guidance.  
              Receiving guidance in a timely manner is critical so escalate above your superior if you do not receive a prompt response. </v-card-text>
          </div>      
          <v-checkbox style="padding: 0px 16px;" v-model="error.errorAcknowledged" label="I have confirmed call scheduling with the client or my superior."/>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="warningDialog=false">Close and Edit</v-btn>
          <v-btn color="green darken-1" class="close-calamity-confirm-btn" :disabled="!errorsAccepted(clientErrors)" text @click="warningDialog = false; submit(true)">Approve and Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
<!-- eslint-enable -->
</template>

<script>
import { mapGetters } from "vuex";
import { CALAMITY_NAMESPACE } from "./store/calamityStore";
import moment from "moment";

export default {
  name: "CalamityCalls",
  data() {
    return {
      minCallsPerHour: 25,
      zoneCodes: {
        "4": "America/Puerto_Rico",
        "5": "EST5EDT",
        "6": "CST6CDT",
        "7": "MST7MDT",
        "8": "PST8PDT",
        "9": "America/Anchorage",
        "10": "Pacific/Honolulu"
      },
      warningDialog: false,
      clientErrors: [],
      sortBy: "CalamityId",
      descending: false,
      subTableSortBy: ["TransitStateId", "ScheduledDeliveryDate"],
      subTableHeaders: [
        {
          text: "Tracking",
          align: "left",
          sortable: true,
          value: "TrackingNumber"
        },
        {
          text: "Notified",
          align: "left",
          sortable: true,
          value: "Notified"
        },
        {
          text: "Scheduled Delivery Date",
          align: "left",
          sortable: true,
          value: "ScheduledDeliveryDate"
        },
        {
          text: "Transit State",
          align: "left",
          sortable: true,
          value: "TransitStateId"
        },
        {
          text: "Time Zone",
          align: "left",
          sortable: true,
          value: "TimeZoneName"
        },
        {
          text: "Value",
          align: "left",
          sortable: true,
          value: "ContentsValue"
        },
        {
          text: "Refrigerated",
          align: "left",
          sortable: true,
          value: "IsRef"
        },
        {
          text: "Ineligble Reasons",
          align: "left",
          sortable: true,
          value: ""
        }
      ],
      headers: [
        {
          text: "Calamity Id",
          align: "left",
          sortable: true,
          value: "CalamityId"
        },
        {
          text: "# Packages",
          align: "left",
          sortable: true,
          value: "TotalPackages"
        },
        {
          text: "# Needs Notification",
          align: "left",
          sortable: true,
          value: "NeedsCalls"
        },
        {
          text: "# Notified",
          align: "left",
          sortable: true,
          value: "Notified"
        },
        {
          text: "# Ineligible",
          align: "left",
          sortable: true,
          value: "Ineligible"
        },
        { text: "", value: "data-table-expand" }
      ],
      show: false,
      submitting: false
    };
  },
  computed: {
    ...mapGetters(CALAMITY_NAMESPACE, ["calamityPackageList"])
  },
  created: /* istanbul ignore next */ function() {
    this.$parent.$on("calamityCalls", this.showDialog);
  },
  methods: {
    getIneligbleReasons(item) {
      var reasons = [];
      if (item.TodayDelivery === -1) reasons.push("Past Delivery Date");
      else if (item.TodayDelivery === 1) reasons.push("Future Delivery Date");
      if (item.IsRTS) reasons.push("RTS");
      if (item.IsDNC) reasons.push("DNC");
      if (item.Notified) reasons.push("Notified");
      if (item.ProtectionStateId === 4) reasons.push("Closed");
      if (item.Tier === 2) reasons.push("Tier 2");
      if (item.RootCauseId === 62) reasons.push("CPU");
      else if (item.RootCauseId === 67) reasons.push("CSR-CPU");
      else if (item.RootCauseId === 79) reasons.push("MON-CPU");
      return reasons.join(", ");
    },
    formatTime(date, format = "YYYY-MM-DD") {
      if (date) moment(date).format(format);
      return moment().format(format);
    },
    selectAll(packageList) {
      var selectable = packageList.filter(x => x.NeedsCalls > 0).length;
      var selected = packageList.filter(x => x.NeedsCalls > 0 && x.isSelected)
        .length;
      if (selectable == selected)
        packageList.forEach(x => {
          x.isSelected = false;
        });
      else
        packageList.forEach(x => {
          if (x.NeedsCalls > 0) x.isSelected = true;
        });
      this.$forceUpdate();
    },
    isSelectAll(packageList) {
      var selectable = packageList.filter(x => x.NeedsCalls > 0).length;
      var selected = packageList.filter(x => x.NeedsCalls > 0 && x.isSelected)
        .length;
      if (selectable === selected) return 1;
      else if (selected === 0) return -1;
      else return 0;
    },
    getTimeZoneCode(code) {
      return moment()
        .tz(this.zoneCodes[code])
        .format("z");
    },
    errorsAccepted(errors) {
      return errors.filter(x => x.errorAcknowledged).length === errors.length;
    },
    getNumberSelectedPackages(data) {
      var total = 0;
      data.CalamityList.forEach(x => {
        if (x.isSelected) total += x.NeedsCalls;
      });
      return total;
    },
    getTotal(summaryList, key) {
      if (!key) key = "NeedsCalls";
      var total = 0;
      summaryList.forEach(x => {
        total += x[key];
      });
      return total;
    },
    forceUpdate() {
      this.$forceUpdate();
    },
    estimateBeyondCuffOff(data) {
      return (
        Math.round(
          (moment(
            this.getEstimatedTimeOfCompletion(data, "YYYY-MM-DD hh:mm A")
          ).diff(
            moment(
              moment().format("YYYY-MM-DD") +
                " " +
                this.getCutoffTime(data.CallOptions)
            )
          ) /
            (1000 * 60 * 60)) *
            100
        ) / 100
      );
    },
    getCutoffTime(options) {
      var optionId = "Option_99";
      if (
        moment()
          .tz(this.zoneCodes[options["Option_102"]])
          .day() === 6
      )
        optionId = "Option_100";
      else if (
        moment()
          .tz(this.zoneCodes[options["Option_102"]])
          .day() === 0
      )
        optionId = "Option_101";
      return moment(
        `${moment().format("YYYY-MM-DD")} ${options[optionId]}`
      ).format("hh:mm A z");
    },
    getEstimatedTimeOfCompletion(data, format = "YYYY-MM-DD hh:mm ") {
      var addedHours = this.getNumberSelectedPackages(data) / data.callsPerHour;
      return moment()
        .add("hours", addedHours)
        .tz(this.zoneCodes[data.CallOptions["Option_102"]])
        .format(format);
    },
    showDialog(payload) {
      this.show = true;
    },
    checkClientSettingErrors() {
      var errors = [];
      for (let clientId in this.calamityPackageList) {
        var callPerHourErr = false;
        var callCenterClosedErr = false;
        if (
          this.calamityPackageList[clientId].callsPerHour >
          this.calamityPackageList[clientId].CallOptions.Option_98
        )
          callPerHourErr = true;
        if (this.estimateBeyondCuffOff(this.calamityPackageList[clientId]) > 0)
          callCenterClosedErr = true;
        if (callCenterClosedErr || callPerHourErr) {
          var errorNum = 0;
          if (callCenterClosedErr && callPerHourErr) errorNum = 3;
          else if (!callCenterClosedErr && callPerHourErr) errorNum = 1;
          else if (callCenterClosedErr && !callPerHourErr) errorNum = 2;
          /* eslint-disable */
          errors.push({
            errorNum: errorNum,
            clientName: this.calamityPackageList[clientId].ClientName,
            errorAcknowledged: false,
            clientCutoffTime: this.getCutoffTime(this.calamityPackageList[clientId].CallOptions),
            clientMaxCalls: this.calamityPackageList[clientId].CallOptions.Option_98,
            clientTimeZoneCode: this.calamityPackageList[clientId].CallOptions.Option_102
          });
          /* eslint-enable */
        }
      }
      return errors;
    },
    hasSelectedCalamity() {
      for (let clientId in this.calamityPackageList) {
        if (
          this.getNumberSelectedPackages(this.calamityPackageList[clientId]) > 0
        )
          return true;
      }
      return false;
    },
    submit(errorAcknowledged) {
      this.clientErrors = this.checkClientSettingErrors();
      if (this.clientErrors.length > 0 && !errorAcknowledged) {
        this.warningDialog = true;
        return;
      } else this.show = false;
      this.submitting = true;
      var payload = [];     
      for (var clientId in this.calamityPackageList) {
        var calamityIds = [];
        this.calamityPackageList[clientId].CalamityList.forEach(x => {
          if (x.isSelected) {            
            var packageData = [];
            x.Packages.forEach(p => {
              packageData.push({
                Id: p.PackageId,
                TimeZone: p.TimeZoneName
              })
            });
            calamityIds.push({
              CalamityId: x.CalamityId,
              Packages: packageData 
            });
          }
        });
        if (calamityIds.length > 0)
          payload.push({
            ClientId: clientId,
            CallsPerHour: this.calamityPackageList[clientId].callsPerHour,
            CalamityPackageIds: calamityIds
          });
      }
      return this.$store
        .dispatch(`${CALAMITY_NAMESPACE}/sendCalamityCalls`, payload)
        .then(res => {
          this.show = false;
          this.submitting = false;
        })
        .catch(
          /* istanbul ignore next */ () => {
            this.submitting = false;
          }
        );
    }
  }
};
</script>
